import { createAction } from 'redux-act';

export const setLiability = createAction('Set liability items');

export const liabilityReset = createAction('Reset liability');

export const setLiabilityPickupData = createAction('Set liability pickup data');
